import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "../analytics/-errorComponent";
import {fetchAnalyticsCaches, type AnalyticsCacheSnapshot, ANALYTICS_CACHE_QUERY_KEY} from "../analytics/-cacheManagement";
import {NotFoundComponent} from "../analytics/-notFoundComponent";
import {PendingComponent} from "../analytics/-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/analytics-cache-management",
)({
    loader: async ({context}) => {
        const caches = await context.queryClient.ensureQueryData<Array<AnalyticsCacheSnapshot>>({
            queryKey: [ANALYTICS_CACHE_QUERY_KEY],
            queryFn: () => fetchAnalyticsCaches({accessToken: context.authenticationStatus.accessToken, intellsysBaseUrl: context.intellsysBaseUrl}),
            staleTime: 0,
        });
        return {accessToken: context.authenticationStatus.accessToken, caches, intellsysBaseUrl: context.intellsysBaseUrl};
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
